export class SearchFacetField {
  public excludedFacet: boolean;

  constructor(
    public field: string,
    public label: string,
    public token: string,
    public isString: boolean,
    public facetLabelCallback: (
      field: string,
      label: string,
      token: string,
      value: string
    ) => any
  ) {}
}
